module.exports = __webpack_public_path__ + "img/sidebar-empty-list-light.4150d167.svg";